import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DynamicHelpListComponent } from 'app/EMR/Doctor/doctor-other-info/dynamic-help-list/dynamic-help-list.component';
import { EMRService } from 'app/EMR/EMR.service';
import { OptoTestDetail } from 'app/EMR/PrimaryExaminationModels/optoTestDetail.model';
import { TestModel } from 'app/EMR/PrimaryExaminationModels/test.model';
import { HelplistService } from 'app/helplist.service';
import { OPDTestMasterComponent } from 'app/masters/opdtest-master/opdtest-master.component';
import { Observable, Subject } from 'rxjs';
import { map, startWith, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-opto_examination',
  templateUrl: './opto_examination.component.html',
  styleUrls: ['./opto_examination.component.scss']
})
export class Opto_examinationComponent implements OnInit {
  destroyopto$: Subject<boolean> = new Subject<boolean>();
  private displayedColumns_optotestdetails: string[] = ['Testname', 'result1', 'result2', 'comment', 'Action'];
  private AddServiceArray: any = [];
  private optotestdetails: MatTableDataSource<OptoTestDetail>;
  private filteredOptions: Observable<TestModel[]>;
  private filteredOptionsEdit: Observable<TestModel[]>;
  private myControl = new FormControl();
  private typeTestname: any;
  private siteType: any;
  private editCache: { [key: string]: any } = {};
  private testname: any;
  private selectId: any;
  private typeTestnames: string;
  private servicelist: any[];
  enabledisablebtn: boolean = false;
  constructor(private dialog: MatDialog, private helplistservice: HelplistService,
    private dashboardService: DashboardService, private emrservice: EMRService) {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => value ? this._filter(value) : this.helplistservice.tests.filter(item => item.isActive == true).slice())
    );

  }

  ngOnInit() {
    this.emrservice.add_OptoTestDetails = {};
    this.enabledisablebtn = true;

    this.emrservice.share.pipe(takeUntil(this.destroyopto$)).subscribe((x: any) => {
      if (x == 3) {
        this.enabledisablebtn = true;
        this.optoTestDetails();
        this.optotestdetails = new MatTableDataSource(this.emrservice.optoTestDetails.slice());
        this.TestupdateEdit();
        this.filteredOptionsEdit = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => value ? this._filter(value) : this.helplistservice.tests.filter(item => item.isActive == true).slice())
        );
      }
    })
    this.emrservice.otshare.pipe(takeUntil(this.destroyopto$)).subscribe((x: any) => {
      if (x == 'section14') {
        this.optoTestDetails();
        this.optotestdetails = new MatTableDataSource(this.emrservice.optoTestDetails.slice());
        this.TestupdateEdit();
        this.filteredOptionsEdit = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => value ? this._filter(value) : this.helplistservice.tests.filter(item => item.isActive == true).slice())
        );
      }
    })

  }
  ngOnDestroy(): void {
    this.destroyopto$.next(true);
    this.destroyopto$.unsubscribe();
    this.servicelist = null;
    this.displayedColumns_optotestdetails = null;

  }
  private _filter(value: string): TestModel[] {
    const filterValue = value.toLowerCase();
    return this.helplistservice.tests.filter(test => (test.testName.toLowerCase().indexOf(filterValue) === 0) && test.isActive == true);
  }

  optoTestDetails() {

    this.emrservice.getOptoTestDetails().pipe(takeUntil(this.destroyopto$)).subscribe(data => {
      this.emrservice.optoTestDetails = data;
      this.optotestdetails = new MatTableDataSource(this.emrservice.optoTestDetails.slice());
      this.TestupdateEdit();
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });
  }



  addOptoTestName() {
    const dialogRef = this.dialog.open(OPDTestMasterComponent, {
      panelClass: "full-width-dialog",
      width: "70%",
      disableClose: true,
      data: {
        isheader: true,
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroyopto$)).subscribe(result => {

    });
  }

  addOptoTestDetails() {
    if (this.emrservice.optometristPermission.isAddPermission == true) {
      document.getElementById("addTestModal").style.display = "block";
      this.typeTestname = '';
      this.typeTestnames = '';
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        map(value => value ? this._filter(value) : this.helplistservice.tests.filter(item => item.isActive == true).slice())
      );
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }

  }

  canceladdTestdetails() {
    document.getElementById("addTestModal").style.display = "none";
    this.emrservice.add_OptoTestDetails = {};


  }


  addTestDetails() {
    let addDetails = this.emrservice.add_OptoTestDetails;
    if (addDetails.fK_OptoTestId == null || addDetails.fK_OptoTestId == 0) {
      return this.dashboardService.openSnackBar("Please Select Test Name", "OK");
    }
    if (!addDetails.fK_OptoTestId || addDetails.fK_OptoTestId == 0) {
      return this.dashboardService.openSnackBar("Please Select Test Name", "OK");
    }
  
    let isDuplicate = this.emrservice.optoTestDetails.some(test => 
      test.fK_OptoTestId == addDetails.fK_OptoTestId 
    );
    if (isDuplicate) {
      return this.dashboardService.openSnackBar("This Record Aleady Exists", "OK");
    }

    this.enabledisablebtn = false;
    addDetails.pK_OptoTestDetailId = 0;
    addDetails.fK_VisitId = this.emrservice.visitid;
    addDetails.fK_OptoTestId = addDetails.fK_OptoTestId ? addDetails.fK_OptoTestId : null;
    addDetails.result1 = addDetails.result1 ? addDetails.result1 : null;
    addDetails.result2 = addDetails.result2 ? addDetails.result2 : null;
    addDetails.comment = addDetails.comment ? addDetails.comment : '';
    addDetails.pK_SynchId = addDetails.pK_SynchId ? addDetails.pK_SynchId : null;
    addDetails.oldoptoID = addDetails.oldoptoID ? addDetails.oldoptoID : null;
    addDetails.isEdit = false;
    addDetails.isDelete = false
    this.emrservice.optoTestDetails.push(addDetails);
    this.optotestdetails = new MatTableDataSource(this.emrservice.optoTestDetails.slice());
    this.TestupdateEdit();
    // this.emrservice.add_OptoTestDetails = {};

    this.canceladdTestdetails();
  }

  saveOptoTest() {
    if (this.emrservice.optometristPermission.isAddPermission == true) {
      this.dashboardService.open_loader_Dialog();
      let testfilterArray = this.emrservice.optoTestDetails.filter(item => item.pK_OptoTestDetailId == 0);

      if (testfilterArray.length != 0) {
        const payload = { "OpdOptoTestDetail": testfilterArray }
        this.emrservice.saveOpdOptoTestDetail(payload).pipe(takeUntil(this.destroyopto$)).subscribe(data => this.success_testdetails(data), err => this.failed_test(err));
      } else {
        this.dialog.closeAll();
        this.dashboardService.openSnackBar("Please Add The Test Name", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Add Permission Denied", "OK");
    }
  }

  success_testdetails(data) {
    if (data['statusCode'] == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
      this.dialog.closeAll();
      this.optoTestDetails();
    } else {
      // if (data['statusCode'] == 1) {
      this.dialog.closeAll();
      this.enabledisablebtn = true;
      this.emrservice.optoTestDetails = [];
      this.emrservice.getPExamStatus();
      this.optoTestDetails();
      this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
      // }
    }

  }

  failed_test(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  deleteOptoTest(row) {

    if (row.pK_OptoTestDetailId > 0) {
      if (this.emrservice.optometristPermission.isDeletePermission == true) {
        this.dashboardService.open_loader_Dialog();
        row.isEdit = true
        row.isDelete = true
        let payload = {
          "OpdOptoTestDetail": [row]
        }
        this.emrservice.saveOpdOptoTestDetail(payload).pipe(takeUntil(this.destroyopto$)).subscribe(
          data => this.success_delete_test(data), err => this.failed_delete_test(err)
        )
      } else {
        this.dashboardService.openSnackBar("Delete Permission Denied", "OK");
      }
    }
    else {
      const index: number = this.emrservice.optoTestDetails.indexOf(row);
      if (index !== -1) {
        this.emrservice.optoTestDetails.splice(index, 1);
        this.optotestdetails = new MatTableDataSource(this.emrservice.optoTestDetails.slice());
      }
      this.dialog.closeAll();
    }
  }

  success_delete_test(data) {
    this.dialog.closeAll();
    this.enabledisablebtn = true;
    this.optoTestDetails();
    this.emrservice.getPExamStatus();
    this.dashboardService.openSnackBar("Record Deleted Successfully", "OK");
  }

  failed_delete_test(err) {
    this.dialog.closeAll();
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("Test Detail Delete Api Failed", "OK");
  }
  selectTestName(event) {

    this.emrservice.add_OptoTestDetails.fK_OptoTestId = event.option.id;
    this.typeTestname = event.option.value;
    this.editCache[this.optoid].data.fK_OptoTestId = event.option.value;
    // this.editCache[this.optoid].data.fK_OptoTestId=event.option.value;
    // this.typeTestnames= this.getTestName(event.option.value);

    // if(this.optoid >0){
    //   this.editCache[this.optoid].data.fK_OptoTestId=event.option.value;
    //   this.typeTestname= this.getTestName(event.option.value);
    // }
    // this.getDyanamicHelplist();
  }
  selectTestNames(event) {

    this.editCache[this.optoid].data.fK_OptoTestId = event.option.value;
    this.typeTestnames = this.getTestName(event.option.value);
    this.getDyanamicHelplist();
  }
  getTestName(id) {
    let optotest = this.helplistservice.tests.filter(item => (item.pkTestId == id) && item.isActive == true);
    return optotest[0]?.testName;
  }
  checkvalue(name) {

    let val = name.trimStart();

    if (val == '') {
      this.emrservice.add_OptoTestDetails.fK_OptoTestId = null;
      this.typeTestname = ''
      // this.optoid =0;
    }
  }
  // helplist pop up 
  reflabstatusPOpup(name, type) {
    const dialogRef = this.dialog.open(DynamicHelpListComponent, {
      panelClass: 'full-width-dialog',
      maxWidth: '33vw',
      disableClose: true,
      width: '33%',
      data: {
        parametertype: name,
        optotest: name
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroyopto$)).subscribe(result => {
      if (result != 0) {
        if (type == 1) {
          this.emrservice.add_OptoTestDetails.result1 = result;
        } else if (type == 2) {
          this.emrservice.add_OptoTestDetails.result2 = result;
        }
      }
    });
  }
  TestRELEArrary: any = [];
  getDyanamicHelplist() {
    this.TestRELEArrary = [];
    this.emrservice.GetPopUpHelpGeneral(this.typeTestnames).pipe(takeUntil(this.destroyopto$)).subscribe((item: any) => {
      this.TestRELEArrary = item;

    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

  }

  // test edit part
  TestupdateEdit(): void {

    this.optotestdetails.data.forEach((item, index) => {
      const id = item.pK_OptoTestDetailId || index;
      this.editCache[id] = {
        edit: false,
        data: { ...item }
      };

    });

  }
  optoid: any;
  Edit(pkid: string, index) {
    if (this.emrservice.optometristPermission.isModifyPermission == true) {
      const id = pkid || index;
      this.editCache[id].edit = true;
      this.optoid = id;
      this.typeTestnames = this.getTestName(this.editCache[id].data.fK_OptoTestId);
      this.getDyanamicHelplist()
    } else {
      this.dashboardService.openSnackBar("Modify Permission Denied", "OK");
    }
  }

  TestSaveEdit(pkid, idx): void {
    const id = pkid || idx;
    let payloadarray = [];
    let isedit
    let editlist = this.editCache[id].data;
    if (editlist.pK_OptoTestDetailId == 0) {
      isedit = false;
    } else {
      isedit = true;
    }

    payloadarray.push({
      "fK_OptoTestId": editlist.fK_OptoTestId,
      "comment": editlist.comment ? editlist.comment : '',
      "result1": editlist.result1,
      "result2": editlist.result2,
      "fK_VisitId": editlist.fK_VisitId,
      "isDelete": false,
      "isEdit": editlist.pK_OptoTestDetailId > 0 ? true : false,
      "oldoptoID": editlist.oldoptoID,
      "pK_OptoTestDetailId": editlist.pK_OptoTestDetailId,
      "pK_SynchId": editlist.pK_SynchId,


    })
    this.editCache[id].edit = false
    let editpayload = {
      "OpdOptoTestDetail": payloadarray
    }

    this.emrservice.saveOpdOptoTestDetail(editpayload).pipe(takeUntil(this.destroyopto$)).subscribe(
      data => this.success_test_update(data), err => this.failed_test_update(err)
    )
  }
  success_test_update(data) {
    if (data['statusCode'] == 10) {
      this.dashboardService.openSnackBar("Alreday exists in the list", "OK");
    } else {
      this.optoTestDetails();
      this.emrservice.getPExamStatus();
      this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
    }
  }
  failed_test_update(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  cancelEdit(pkid, idx): void {
    const id = pkid || idx;
    this.editCache[id].edit = false;
  }

}
